  import React, { useRef } from 'react';
  import { useNavigate } from 'react-router-dom';
  import { Carousel } from 'react-responsive-carousel';
  import 'react-responsive-carousel/lib/styles/carousel.min.css';
  import axiosClient, { postData, getData } from '../global/Globalapi';
  import { useEffect } from 'react';

  const Demo_1 = ({ bannerImages, selectedCategory }) => {
    const navigate = useNavigate();
    const bottomRef = useRef(null);
    const baseURL = axiosClient.defaults.baseURL;

    useEffect(()=>{
      // const Check_Delivery_Partners = async ()=>{
      //   const res = await getData("/shiprocket/check",{method:"GET"})
      // }

      // const Check_delivery_Parameters = async () => {
      //   try {
      //     console.log("Frontend Serviceability:");
      //     // pass payload directly (axios expects data as second arg)
      //     const res = await postData("/shiprocket/availability", {
      //       cod: true,
      //       weight: 1,
      //     });
      //     console.log('Serviceability response (frontend):', res.data);
      //   } catch (err) {
      //     console.error('Serviceability request failed (frontend):', err);
      //   }
      // };

      // Check_Delivery_Partners();
      // Check_delivery_Parameters();
    }, []);

    const defaultContent = {
      title: 'Discover Our Premium Collections',
      description: 'Explore our freshly baked delights made with love',
      defaultImage: '' 
    };

  // ✅ Move encodeId function here (inside component but before it's used)
  const encodeId = (id) => {
    try {
      return btoa(id.toString());
    } catch {
      return id;
    }
  };
    return (
      <div className="men-section-bg"> 
        <div className="max-w-7xl mx-auto px-4 py-6 md:py-8 lg:py-10">
          {/* <div className="flex flex-col md:flex-row items-center gap-8 lg:gap-12 h-full w-full"> */}
          <div className="flex flex-col md:flex-row items-center gap-8 lg:gap-12 h-full w-full mt-6 md:mt-10 lg:mt-20">

            <div className="md:w-1/2 space-y-4 md:space-y-6">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
                {selectedCategory?.category_name || defaultContent.title}
              </h1>
              <p className="text-lg text-black-300 max-w-lg">
                {selectedCategory?.category_description || defaultContent.description}
              </p>
              {/* <button 
                className="bg-white text-gray-900 px-6 py-3 rounded-full font-semibold hover:bg-gray-200 transition duration-300 transform hover:scale-105"
                onClick={() => {
                  if (selectedCategory) {
                    navigate(`/shopping?`);
                  } else {
                    if (bottomRef.current) {
                      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                  }
                }}
              >
                Shop Now
              </button> */}
               {/* <button 
              className="bg-white text-gray-900 px-6 py-3 rounded-full font-semibold hover:bg-gray-200 transition duration-300 transform hover:scale-105"
              onClick={() => {
                if (selectedCategory) {
                  const encodedId = encodeId(selectedCategory.product_category_id);
                  navigate(`/shopping?product=${encodedId}`);
                } else {
                  if (bottomRef.current) {
                    bottomRef.current.scrollIntoView({ behavior: 'smooth' });
                  }
                }
              }}
            >
              Shop Now
            </button> */}
            </div>

            {/* <div className="md:w-1/2 w-full"> */}
            <div className="md:w-1/2 w-full">

              {bannerImages?.length > 0 ? (
                <Carousel
                  showArrows={true}
                  infiniteLoop={true}
                  showThumbs={false}
                  showStatus={false}
                  autoPlay={true}
                  interval={5000}
                  stopOnHover={true}
                  className="rounded-xl overflow-hidden shadow-2xl"
                >
                  {bannerImages.map((image) => (
                    // <div key={image.id} className="w-full h-full mt-20 aspect-video">
                      <div key={image.id}  
                      //  className="w-full h-[250px] sm:h-[320px] md:h-[380px] lg:h-[420px]"
                      // className="w-full h-[250px] sm:h-[320px] md:h-[380px] lg:h-[300px] object-cover"
                      // className="w-full h-[220px] sm:h-[260px] md:h-[300px] lg:h-[320px]"
                       className="w-full h-[180px] sm:h-[220px] md:h-[260px] lg:h-[280px] flex items-center justify-center"



                       >
                      <img
                        src={`${baseURL}/uploads/product_category_image/${image.fileName}` || ''}
                        alt={image.description || selectedCategory?.category_name}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defaultContent.defaultImage;
                        }}
                      />
                    </div>
                  ))}
                </Carousel>
              ) : (
                <div className="w-full aspect-video bg-gray-700 rounded-xl flex flex-col items-center justify-center p-8 text-center">
                  <img
                    src={defaultContent.defaultImage}
                    alt="Default banner"
                    className="w-full h-full object-cover rounded-xl"
                  />
                  <p className="mt-4 text-white">No images available for this category</p>
                </div>
              )}
            </div>
          </div>
        </div>
        <div ref={bottomRef}></div>
      </div>
    );
  };

  export default Demo_1;